import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication.service';
import { EntityService } from '@app/entity/entity.service';
import { PosConfigurationDTO } from '@models/pos';
import { Observable, of, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DropdownComponent } from '@app/shared';

@Component({
  selector: 'pos-settings',
  templateUrl: './pos-settings.component.html',
  styleUrls: ['./pos-settings.component.css']
})
export class PosSettingsComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild("componentDimmer") componentDimmer: ElementRef;

  public configurationDTO: PosConfigurationDTO;
  private rxSubscription: Subscription = new Subscription();
  private fetchingComponentData: boolean;

  @ViewChild("versionDropdown") private versionDropdown: DropdownComponent;

  constructor(
    private entityService: EntityService,
    private authService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.load();
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    if (this.rxSubscription) {
      this.rxSubscription.unsubscribe();
    }
  }

  private load() {
    const entityId = this.authService.getUserSelectedEntityId();
    if (entityId) {
      this.setComponentDimmerVisibility(true);
      this.rxSubscription.add(
        this.entityService
          .getPosConfigurations()
          .pipe(finalize(() => this.setComponentDimmerVisibility(false)))
          .subscribe((data) => {
            this.configurationDTO = data;
          })
      );
    }
  }

  save(): void {
    const entityId = this.authService.getUserSelectedEntityId();
    if (entityId) {
      this.setComponentDimmerVisibility(true);
      this.rxSubscription.add(
        this.entityService
          .updatePosConfigurations(this.configurationDTO)
          .pipe(finalize(() => this.setComponentDimmerVisibility(false)))
          .subscribe((data) => {
            this.configurationDTO = data;
          })
      );
    }
  }

  onCheckboxChange(value: boolean): void {
    this.save();
  }

  private setComponentDimmerVisibility(visible: boolean): void {
    const dimmerElement = $(this.componentDimmer.nativeElement).dimmer({
      duration: { show: 400, hide: 800 },
    });

    if (visible) {
      this.fetchingComponentData = true;
      dimmerElement.dimmer("show");
    } else {
      dimmerElement.dimmer("hide");
      this.fetchingComponentData = false;
    }
  }
}
